import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LocalService, PageKey } from '../../../service/local.service';

@Component({
  selector: 'app-pricing-calculator',
  templateUrl: './pricing-calculator.component.html',
  styleUrls: ['./pricing-calculator.component.scss']
})
export class PricingCalculatorComponent implements OnInit {

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.PricingCalculator);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
    });
  }

}
